var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex-row justify-content-end"},[_c('a',{staticClass:"k98-link",attrs:{"href":"https://k-98.ru","target":"_blank","rel":"noopener"},on:{"mouseenter":_vm.pickColor}},[_vm._v(" сделано "),_c('span',{staticClass:"brand",style:(_vm.brandStyle)},[_vm._v("k-98")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }